/* eslint-disable no-param-reassign */
import flow from 'lodash/flow';

const addTopCategoryAsAnOption = group => {
  const label = `${group.label} (Top category)`;
  return {
    ...group,
    options: [
      {
        label,
        selectLabel: label,
        value: group.id,
        id: group.id,
      },
    ].concat(group.options),
  };
};

const transformOptions = group => ({
  ...group,
  options: group.options.map(option => ({
    ...option,
    value: option.id,
    selectLabel: `${option.label} (${group.label})`,
  })),
});

export default function adjustCategories(categories) {
  return categories.map(flow(transformOptions, addTopCategoryAsAnOption));
}
/* eslint-enable no-param-reassign */
